<template>
  <ConclusionStep
    status="positive"
    :title="dataCompleted.title"
    :show-navbar="false"
  >
    <BaseText
      size="p4"
      as="p"
      :color="NebraskaColors.elementSecondary"
      class="description"
    >
      {{ dataCompleted.subtitle }}
    </BaseText>

    <template #button-primary>
      <ButtonPrimary
        label="Ir para Trade"
        size="large"
        @click="handleNextClick"
      />
    </template>
  </ConclusionStep>
</template>

<script lang="ts" setup>
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonPrimary,
  ConclusionStep
} from '@warrenbrasil/nebraska-web';
import { useRouter } from 'vue-router/composables';
import { Hiring } from '../../../../services/paid-custody';

const router = useRouter();

const { dataCompleted } = defineProps<{
  dataCompleted: Hiring;
}>();

const handleNextClick = () => {
  return router.push({ name: 'trade' });
};
</script>

<style lang="less" scoped>
:deep(.flow-conclusion__content) {
  max-width: 492px;
}

.description {
  text-align: center;
}
</style>
